/* 4 Nov: Gooten dog hoodies. Each product has several mockup photos per colour (one per size, or an XS-M photo and an L-3XL photo), plus sometimes a removed grey colour and duplicate preview photos, so the photos jumped around as shoppers tapped sizes and grey kept appearing. This only changes what is SHOWN on the page: it keeps one photo per colour, makes every size of a colour use that photo, hides photos of colours the product no longer sells, and shows only the chosen colour. Nothing in Shopify products, variants or the Gooten sync is changed. Products without Gooten-style photo descriptions are left alone. To undo: remove the gooten-gallery.js line in snippets/meta-tags.liquid. */
(function () {
  'use strict';
  var list = document.querySelector('.product__media-list');
  if (!list) return;
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function parse(a) {
    var m = a.match(/doggieskins-\d+-([a-z0-9]+)-([a-z0-9]+)-cb/i);
    if (m) return { col: norm(m[2]), pref: m[1].toUpperCase() === 'M' };
    m = a.match(/\bin ([a-z][a-z ]*?),\s*sizes?\s+([a-z0-9]+)\s*-\s*([a-z0-9]+)/i);
    if (m) return { col: norm(m[1]), pref: /^xs$/i.test(m[2]) };
    return null;
  }
  var vdata = null, vscript = document.querySelector('script[data-variants-json]');
  try { vdata = JSON.parse(vscript.textContent); } catch (e) {}
  var sold = {};
  (vdata || []).forEach(function (v) { (v.options || []).forEach(function (o) { sold[norm(o)] = true; }); });
  var rows = [].slice.call(list.children).map(function (el) {
    var im = el.querySelector('img');
    var a = im ? (im.alt || '') : '';
    var p = parse(a);
    return { el: el, alt: a, col: p ? p.col : null, pref: p ? p.pref : false };
  });
  var gooten = rows.filter(function (r) { return r.col; });
  if (!gooten.length || !vdata) return;
  var best = {};
  gooten.forEach(function (r) {
    if (!best[r.col] || (r.pref && !best[r.col].pref)) best[r.col] = r;
  });
  rows.forEach(function (r) {
    var drop = false;
    if (r.col) drop = (r.col === 'graniteheather' && !sold.graniteheather) || (best[r.col] !== r);
    else if (/^generated-preview/i.test(r.alt)) drop = true;
    if (drop) { if (r.el.parentNode) r.el.parentNode.removeChild(r.el); }
    else if (r.col) r.el.setAttribute('data-sww-col', r.col);
  });
  /* every size of a colour points at that colour's one photo */
  try {
    vdata.forEach(function (v) {
      (v.options || []).forEach(function (o) {
        var b = best[norm(o)];
        var id = b && b.el.getAttribute('data-media-id');
        if (id) v.media = parseInt(id, 10);
      });
    });
    vscript.textContent = JSON.stringify(vdata);
  } catch (e) {}
  function selCol() {
    var c = null;
    [].forEach.call(document.querySelectorAll('.product__variant-form .product__option'), function (f) {
      var l = f.querySelector('legend');
      if (!c && l && /colo/i.test(l.textContent)) {
        var r = f.querySelector('input[type="radio"]:checked');
        if (r) c = norm(r.value);
      }
    });
    return c;
  }
  function apply() {
    var c = selCol();
    var has = c && [].some.call(list.children, function (x) { return x.getAttribute('data-sww-col') === c; });
    [].forEach.call(list.children, function (x) {
      var col = x.getAttribute('data-sww-col');
      if (!col) return;
      var want = (!has || col === c) ? '' : 'none';
      if (x.style.display !== want) x.style.display = want;
    });
    if (has) {
      var mine = [].filter.call(list.children, function (x) { return x.getAttribute('data-sww-col') === c; })[0];
      var cur = [].filter.call(list.children, function (x) { return x.classList.contains('is-active'); })[0];
      if (mine && (!cur || cur.style.display === 'none')) {
        [].forEach.call(list.children, function (x) { if (x !== mine && x.classList.contains('is-active')) x.classList.remove('is-active'); });
        mine.classList.add('is-active');
      }
    }
  }
  if (window.MutationObserver) new MutationObserver(apply).observe(list, { attributes: true, subtree: true, attributeFilter: ['style', 'class'], childList: true });
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest || !t.closest('.product__variant-form')) return;
    [0, 80, 250, 700].forEach(function (ms) { window.setTimeout(apply, ms); });
  });
  apply();
  [300, 800, 1600].forEach(function (ms) { window.setTimeout(apply, ms); });
})();
